import React from 'react';

const styles = {
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px'
    },
    header: {
        textAlign: 'center',
        marginBottom: '40px'
    },
    title: {
        fontSize: '32px',
        color: '#333',
        marginBottom: '10px'
    },
    subtitle: {
        fontSize: '18px',
        color: '#666'
    },
    gameGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px',
        padding: '20px'
    },
    gameCard: {
        border: '2px solid #ccc',
        borderRadius: '10px',
        padding: '20px',
        backgroundColor: 'white',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        textDecoration: 'none',
        color: 'inherit'
    },
    activeGame: {
        borderColor: '#4CAF50',
        backgroundColor: '#f0f9f0'
    },
    comingSoon: {
        borderColor: '#ccc',
        backgroundColor: '#f5f5f5',
        opacity: 0.7,
        cursor: 'default'
    },
    gameTitle: {
        fontSize: '24px',
        marginBottom: '10px',
        color: '#333'
    },
    gameDescription: {
        fontSize: '16px',
        color: '#666',
        marginBottom: '15px'
    },
    statusTag: {
        display: 'inline-block',
        padding: '5px 10px',
        borderRadius: '15px',
        fontSize: '14px',
        marginTop: '10px'
    },
    activeTag: {
        backgroundColor: '#4CAF50',
        color: 'white'
    },
    comingSoonTag: {
        backgroundColor: '#9e9e9e',
        color: 'white'
    }
};

function SynTacticHub() {
    const games = [
        {
            id: 'picture-picker',
            title: 'Picture Picker',
            description: 'Match the correct picture to the given sentence.',
            status: 'active',
            url: 'https://syntactic-picture-picker.vercel.app'
        },
        {
            id: 'thats-not-right',
            title: "That's Not Right",
            description: 'Find the sentence that does NOT match the picture.',
            status: 'active',
            url: 'https://syntactic-thats-not-right.vercel.app'
        },
        {
            id: 'thats-right',
            title: "That's Right",
            description: 'Choose the sentence that correctly describes the picture.',
            status: 'active',
            url: 'https://syntactic-thats-right.vercel.app'
        },
        {
            id: 'syntactile-words-redux',
            title: 'Syntactile Words',
            description: 'Move the words to fit the picture',
            status: 'active',
            url: 'https://syntactile-words-redux.vercel.app'
        },
        {
            id: 'word-scramble',
            title: 'Word Scramble',
            description: 'Unscramble words to improve vocabulary',
            status: 'active',
            url: 'https://word-scramble-game-2.vercel.app/'
        },
        {
            id: 'game6',
            title: 'Game 6',
            description: 'Coming Soon',
            status: 'coming-soon'
        },
        {
            id: 'game7',
            title: 'Game 7',
            description: 'Coming Soon',
            status: 'coming-soon'
        },
        {
            id: 'game8',
            title: 'Game 8',
            description: 'Coming Soon',
            status: 'coming-soon'
        }
    ];

    const launchGame = (game) => {
        if (game.status === 'active' && game.url) {
            window.open(game.url, '_blank');
        }
    };

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.title}>SynTactic Games</h1>
                <p style={styles.subtitle}>A suite of language learning games</p>
            </header>

            <div style={styles.gameGrid}>
                {games.map((game) => (
                    <div
                        key={game.id}
                        onClick={() => launchGame(game)}
                        style={{
                            ...styles.gameCard,
                            ...(game.status === 'active' ? styles.activeGame : styles.comingSoon)
                        }}
                    >
                        <h2 style={styles.gameTitle}>{game.title}</h2>
                        <p style={styles.gameDescription}>{game.description}</p>
                        <span
                            style={{
                                ...styles.statusTag,
                                ...(game.status === 'active' ? styles.activeTag : styles.comingSoonTag)
                            }}
                        >
                            {game.status === 'active' ? 'Play Now' : 'Coming Soon'}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SynTacticHub;